export default __webpack_public_path__ + "static/media/upper-right-arrow.d3d5ace5.svg";